import type { ImportConfigStatus } from '../types/stockImports.types'

export const acquireStockImportRun = (
  runningKeys: Set<string>,
  key: string
) => {
  if (runningKeys.has(key)) return false
  runningKeys.add(key)
  return true
}

export const isStockImportLiveRunAllowed = (status: ImportConfigStatus) =>
  status !== 'ARCHIVED' && status !== 'ERROR_SUSPENDED'

export const isStockImportTrialRunAllowed = (status: ImportConfigStatus) =>
  status !== 'ARCHIVED'
